exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-container[data-v-6f0a3c94] {\n  overflow-x: auto;\n}\n.table-tr[data-v-6f0a3c94]:nth-child(odd) {\n  background: #f9fbfc;\n}\n.table-tr[data-v-6f0a3c94]:hover {\n  background: #cceaed;\n}\n.btn-default.reset-btn[data-v-6f0a3c94] {\n  margin-left: 0.5rem;\n  border-radius: .25rem;\n  padding: 6px 12px;\n}\n", ""]);

// exports
